import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DynamicFeedOutlinedIcon from '@mui/icons-material/DynamicFeedOutlined';
import { useTranslation } from 'react-i18next';
import Repository from './Repository';
import { ListItemIcon, ListItemText, Snackbar } from '@mui/material';
import { Alert } from '../ContextMenu/WorkflowGroupActions/NewWorkflowGroup';
import LightTooltip from '../../commonComponents/LightTooltip';

export const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));

export default function RepositoryButton() {
    const { t } = useTranslation();
    const { permissions } = useSelector((state) => state.userPermissions);
    const [anchorEl, setAnchorEl] = useState(null);
    const [option, setOption] = useState(null);
    const [tpDisabled, setTpDisabled] = useState(true);
    const [ddDisabled, setDdDisabled] = useState(true);
    const [trDisabled, setTrDisabled] = useState(true);
    const [adDisabled, setAdDisabled] = useState(true);
    const [pcDisabled, setPcDisabled] = useState(true);
    const [awDisabled, setAwDisabled] = useState(true);
    const [snackbarState, setSnackbarState] = useState({
        isOpen:false,
        severity:'success',
        message:''
    })
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setOption(null);
    };

    const handleOpen = (num) =>{
        setOption(num);
        setAnchorEl(null);
    }

    const handleCloseSnackbar = (event, reason) => {
        if (reason === "clickaway") {
          return;
        }
        setSnackbarState({
            isOpen:false,
            severity:'success',
            message:''
        });
    };

    useEffect(() => {
      if (permissions?.length > 0) {
        //Trading Partner Permissions
        if (
          permissions.includes("TRADING_PARTNER_RIGHTS") ||
          permissions.includes("TP_ADMINISTRATOR_RIGHTS") ||
          permissions.includes("TRADING_PARTNER_RIGHTS_MODIFY_VALUE_ONLY") ||
          permissions.includes("TRADING_PARTNER_RIGHTS_VIEW_ONLY")
        ) {
          setTpDisabled(false);
        }

        //Data Depot Permissions
        if (
          permissions.includes("DATA_DEPOT_RIGHTS") 
        ) {
          setDdDisabled(false);
        }

        //Tracking Reports Permissions
        if (
          permissions.includes("TRACKING_REPORTS_RIGHTS") ||
          permissions.includes("TRACKING_REPORTS_RIGHTS_VIEW_ONLY")
        ) {
          setTrDisabled(false);
        }
        

        //Account Data Permissions
        if (
          permissions.includes("ACCOUNT_DATA_RIGHTS")
        ) {
          setAdDisabled(false);
        }

        //Predefined Connections Permissions
        if (
          permissions.includes("DATA_CONNECTIONS_RIGHTS")
        ) {
          setPcDisabled(false);
        }

        //Accelerator Wizard Permissions
        if (
          permissions.includes("ACCELERATOR_RIGHTS")
        ) {
          setAwDisabled(false);
        }
        
      } else {
        setTpDisabled(true);
        setDdDisabled(true);
        setTrDisabled(true);
        setAdDisabled(true);
        setPcDisabled(true);
        setAwDisabled(true);
      }
    }, [permissions]);
    
    return (
      <div>
        <Button
          id="demo-customized-button"
          aria-controls={open ? "demo-customized-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          variant="outlined"
          className="margin-right-4"
          disableElevation
          onClick={handleClick}
          startIcon={<DynamicFeedOutlinedIcon />}
          endIcon={<KeyboardArrowDownIcon />}
          size='small'
          sx={{height: "34px"}}
        >
          {t("MNU_REPOSITORY")}
        </Button>
        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{
            "aria-labelledby": "demo-customized-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          {/* Trading Partner */}
          {/* use this block if we want the menu item to be disabled but still showing for user */}
          {/* {tpDisabled ? (
            <LightTooltip title={"Insufficient User Permission"}>
              <MenuItem onClick={() => handleOpen(1)} disableRipple disabled={true}>
                <div className='flex align-center'>
                  <span className="rep-partner-exchange"></span>
                  <span className='font-12'>{t("DIAG_TRADING_PARTNER_TIT")}</span>
                </div>
              </MenuItem>
            </LightTooltip>
          ) : (
            <MenuItem onClick={() => handleOpen(1)} disableRipple>
              <div className='flex align-center'>
                <span className="rep-partner-exchange"></span>
                <span className='font-12'>{t("DIAG_TRADING_PARTNER_TIT")}</span>
              </div>
            </MenuItem>
          )} */}

          {/* Trading Partner */}
          {/* use this block if we want the menu item to be hidden*/}
          {!tpDisabled && (
            <MenuItem onClick={() => handleOpen(1)} disableRipple>
              <div className='flex align-center'>
                <span className="rep-partner-exchange"></span>
                <span className='font-12'>{t("DIAG_TRADING_PARTNER_TIT")}</span>
              </div>
            </MenuItem>
          )}

          {/* Data Depot */}
          {/* use this block if we want the menu item to be disabled but still showing for user */}
          {/* {ddDisabled ? (
            <LightTooltip title={"Insufficient User Permission"}>
              <MenuItem onClick={() => handleOpen(2)} disableRipple disabled={true}>
                <div className='flex align-center'>
                  <span className="rep-data-depot"></span>
                  <span className='font-12'>{t("DATA_DEPOT")}</span>
                </div>
              </MenuItem>
            </LightTooltip>
          ) : (
            <MenuItem onClick={() => handleOpen(2)} disableRipple>
              <div className='flex align-center'>
                <span className="rep-data-depot"></span>
                <span className='font-12'>{t("DATA_DEPOT")}</span>
              </div>
            </MenuItem>
          )} */}

          {/* Data Depot */}
          {/* use this block if we want the menu item to be hidden*/}
          {!ddDisabled && (
            <MenuItem onClick={() => handleOpen(2)} disableRipple>
              <div className='flex align-center'>
                <span className="rep-data-depot"></span>
                <span className='font-12'>{t("DATA_DEPOT")}</span>
              </div>
            </MenuItem>
          )}

          {/* Tracking Reports  */}
          {/* use this block if we want the menu item to be disabled but still showing for user */}
          {/* {trDisabled ? (
            <LightTooltip title={"Insufficient User Permission"}>
              <MenuItem onClick={() => handleOpen(3)} disableRipple disabled={true}>
                <div className='flex align-center'>
                  <span className="rep-tracking-reports"></span>
                  <span className='font-12'>{t("LBL_TRACKING_REPORTS")}</span>
                </div>
              </MenuItem>
            </LightTooltip>
          ) : (
            <MenuItem onClick={() => handleOpen(3)} disableRipple>
              <div className='flex align-center'>
                <span className="rep-tracking-reports"></span>
                <span className='font-12'>{t("LBL_TRACKING_REPORTS")}</span>
              </div>
            </MenuItem>
          )} */}
          {/* Tracking Reports  */}
          {/* use this block if we want the menu item to be hidden*/}
          {!trDisabled && (
            <MenuItem onClick={() => handleOpen(3)} disableRipple>
              <div className='flex align-center'>
                <span className="rep-tracking-reports"></span>
                <span className='font-12'>{t("LBL_TRACKING_REPORTS")}</span>
              </div>
            </MenuItem>
          )}

          {/* Account Data */}
          {/* use this block if we want the menu item to be disabled but still showing for user */}
          {/* {adDisabled ? (
            <LightTooltip title={"Insufficient User Permission"}>
              <MenuItem onClick={() => handleOpen(4)} disableRipple disabled={true}>
                <div className='flex align-center'>
                  <span className="rep-account-data"></span>
                  <span className='font-12'>{t("ACCOUNT_DATA_RIGHTS")}</span>
                </div>
              </MenuItem>
            </LightTooltip>
          ) : (
            <MenuItem onClick={() => handleOpen(4)} disableRipple>
              <div className='flex align-center'>
                <span className="rep-account-data"></span>
                <span className='font-12'>{t("ACCOUNT_DATA_RIGHTS")}</span>
              </div>
            </MenuItem>
          )} */}

          {/* Account Data */}
          {/* use this block if we want the menu item to be hidden*/}
          {!adDisabled && (
            <MenuItem onClick={() => handleOpen(4)} disableRipple>
              <div className='flex align-center'>
                <span className="rep-account-data"></span>
                <span className='font-12'>{t("ACCOUNT_DATA_RIGHTS")}</span>
              </div>
            </MenuItem>
          )}
          
          {/* Predefined Connections */}
          {/* use this block if we want the menu item to be disabled but still showing for user */}
          {/* {pcDisabled ? (
            <LightTooltip title={"Insufficient User Permission"}>
              <MenuItem onClick={() => handleOpen(5)} disableRipple disabled={true}>
                <div className='flex align-center'>
                  <span className="rep-predefined-conn"></span>
                  <span className='font-12'>{t("BTN_PREDEF_CONN")}</span>
                </div>
              </MenuItem>
            </LightTooltip>
          ) : (
            <MenuItem onClick={() => handleOpen(5)} disableRipple>
              <div className='flex align-center'>
                <span className="rep-predefined-conn"></span>
                <span className='font-12'>{t("BTN_PREDEF_CONN")}</span>
              </div>
            </MenuItem>
          )} */}

          {/* Predefined Connections */}
          {/* use this block if we want the menu item to be hidden*/}
          {!pcDisabled && (
            <MenuItem onClick={() => handleOpen(5)} disableRipple>
              <div className='flex align-center'>
                <span className="rep-predefined-conn"></span>
                <span className='font-12'>{t("BTN_PREDEF_CONN")}</span>
              </div>
            </MenuItem>
          )}

          {/* Accelerator Wizard */}
          {!awDisabled && (
            <MenuItem onClick={() => handleOpen(7)} disableRipple>
              <div className='flex align-center'>
                <span className="rep-accelerator-wizard"></span>
                <span className='font-12'>Accelerator Wizard</span>
              </div>
            </MenuItem>
          )}
          
        </StyledMenu>
        <Repository
          setSnackbar={setSnackbarState}
          option={option}
          setOption={setOption}
          handleClose={handleClose}
          origin="repository"
        />
        <Snackbar
          open={snackbarState.isOpen}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}>
          <Alert
            severity={snackbarState.severity}
            elevation={6}
            variant="filled">
            {snackbarState.message}
          </Alert>
        </Snackbar>
      </div>
    );
}
